import React from "react";
import { NextSeo } from "next-seo";
export default function Seo({ seo }) {
  const {
    slug,
    metaTitle = "Soul Scale | Consulting that Strengthens the Development Sector — Finance, Research and Climate Solutions for Informal Workers",
    metaDescription = "Soulscale, helps development organisations strengthen financial systems, ensure statutory compliance, and resolve complex challenges. Focus on driving impact—we’ll take care of your financial management.",
    metaImage = "https://soulscale.org/soul-scale-512x512.webp",
  } = seo;
  return (
    <NextSeo
      title={metaTitle}
      description={metaDescription}
      url={`https://soulscale.org/${slug}`}
      canonical={`https://soulscale.org/${slug}`}
      openGraph={{
        type: "website",
        locale: "en_IE",
        site_name: "Soul Scale",
        url: `https://soulscale.org/${slug}`,
        title: metaTitle,
        description: metaDescription,
        images: [
          {
            url: metaImage,
            width: 140,
            height: 140,
            alt: "Soul Scale",
          },
        ],
      }}
    />
  );
}
